import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import ResignationList from '../resignationList/index';
import ResignationDetail from '../resignationDetail/index';


import { ResignationProvider } from '../context/resignationContext';

function ResignationRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"Resignations HEREEEEEEEEEEEEE")

  return (
    <ResignationProvider>
    <Routes>
       <Route path="/" redirect element={<Outlet />}>   
       <Route index element={<ResignationList />} />      {/*  Matches `/resignations` */}

       <Route path=":id" element={<ResignationDetail />} /> 
       {/* <Route path="/assign-resignation" element={<AssignResignation />} />  */}

      </Route>
    </Routes>
    </ResignationProvider>
  );
}

export default ResignationRouter;
